import { useEffect } from "react";
import { useHistory } from "react-router";
import { useAppContext } from "../../../context/AuthContext";
import EnumGroup from "../../../utils/enum/EnumGroup";

export default function Home() {
  const { authData } = useAppContext();

  const history = useHistory();

  useEffect(() => {
    const group = authData?.user.group.group;

    if (group === EnumGroup.AUTHOR) {
      history.push("/manuscript/view");
    } else if (group === EnumGroup.REVIEWER) {
      history.push("/reviewerToDoList");
    } else if (group === EnumGroup.ASSISTANT) {
      history.push("/assitantEditorList");
    } else if ([EnumGroup.EDITOR, EnumGroup.ASSOCIATE_EDITOR].includes(group)) {
      history.push("/toDoList");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
}
